// import { useMediaQuery } from "react-responsive"
import { useRef } from 'react'

import Normal from "./ui/Normal"
import NormalBreak from "./ui/NormalBreak"
// import Split from "./ui/Split"

import useGetEventDetail from "entity/event/useGetEventDetail"

import useEventInfor from "entity/event/useEventInfor"
import useSupabaseRealtime from "entity/event/useSupabaseRealtime"
import ConnectionStatus from "shared/ui/ConnectionStatus"
import Loading from "./ui/Loading"
import NavigationConfirmModal from "shared/ui/NavigationConfirmModal"
import useNavigationBlock from "shared/hooks/useNavigationBlock"
import useNavigationBlockPreference from "shared/hooks/useNavigationBlockPreference"
import SupabaseConnectError from 'shared/ui/SupabaseConntectError'

const Timer = () => {
    const wrapperRef = useRef(null)
    // 단일 창 뷰포트 1280 이상 기준 / 이중 창 뷰포트 980 이상 기준
    // const isSplit = useMediaQuery({
    //     "query": "(max-width: 1439px)"
    // })

    // Navigation blocking state with persistent preference
    const [enableNavigationBlock, setEnableNavigationBlock] = useNavigationBlockPreference()
    const { showModal, confirmNavigation, cancelNavigation, navigateWithConfirm } = useNavigationBlock(enableNavigationBlock)

    // 초기 데이터 설정을 위한 백엔드 요청
    const [eventData] = useGetEventDetail()
        // 백엔드 데이터 매핑용 State
    const { eventName, logoImg, prizeData, infoData, success, setInfoData } = useEventInfor(eventData)
    const {timeData, isLoading, countDown, nextBreak, regClose, elapsedTime, elapsedTimeDisplay, 
        supabaseConnectError, supabaseConnectErrorStatus} = useSupabaseRealtime(success, setInfoData,eventData)
    return (
        <div style={{position: "relative"}}>
            <ConnectionStatus />
            {supabaseConnectError && <SupabaseConnectError isVisible={supabaseConnectError} status={supabaseConnectErrorStatus} />}
            {timeData?.level === "break"
                ? <NormalBreak countDown={countDown}  timeData={timeData} infoData={infoData}
                logoImg={logoImg} eventName={eventName} eventData={eventData}
                navigationBlock={enableNavigationBlock} setNavigationBlock={setEnableNavigationBlock}
                navigateWithConfirm={navigateWithConfirm}/>

                : <Normal elapsedTime={elapsedTime} elapsedTimeDisplay={elapsedTimeDisplay} countDown={countDown} nextBreak={nextBreak} regClose={regClose}
                timeData={timeData} prizeData={prizeData} infoData={infoData} logoImg={logoImg} eventName={eventName} eventData={eventData} wrapperRef={wrapperRef}
                navigationBlock={enableNavigationBlock} setNavigationBlock={setEnableNavigationBlock}
                navigateWithConfirm={navigateWithConfirm} />
            }

            {(isLoading) && <Loading />}

            <NavigationConfirmModal
                isOpen={showModal}
                onConfirm={confirmNavigation}
                onCancel={cancelNavigation}
                title="페이지 나가기"
                message="이 페이지를 떠나시겠습니까?"
            />
        </div>
    )
}

export default Timer
